"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvoiceConverterFintech = void 0;
var _helpers = require("../helpers");
var _constants = require("../constants");
var _constants2 = require("../../company/constants");
var _helpers2 = require("../../company/helpers");
var _helpers3 = require("../../helpers");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class InvoiceConverterFintech {
  constructor({
    invoices = [],
    company = {}
  }) {
    _defineProperty(this, "invoices", []);
    _defineProperty(this, "company", {});
    this.invoices = invoices;
    this.company = company;
  }
  createAllCapsWithoutFirstElement(rows) {
    const newRows = [];
    const firstRow = rows[0] + "\n";
    const restRows = [rows.slice(1).join("\r\n").toLocaleUpperCase()];
    newRows.push(firstRow + restRows);
    return newRows;
  }
  showStateTax(item) {
    const itemPrice = item.price * item.qty;
    const totalTax = item.total - itemPrice;
    return (0, _helpers3.formatAmount)(totalTax / item.qty).replace("$", "");
  }
  showEmptyStringIfNull(date, timeZone = "UTC") {
    const options = {
      timeZone: timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit"
    };
    return date ? new Date(date).toLocaleString("en-US", options) : "";
  }
  buildRows(invoice, fintechId, i, isCustomerInvoiceNumberingActive) {
    var _invoice$statusInfo, _invoice$customer;
    const fintechRows = [];
    const invoicedStatusInfo = (_invoice$statusInfo = invoice.statusInfo) === null || _invoice$statusInfo === void 0 ? void 0 : _invoice$statusInfo.find(info => info.new_status === _constants.InvoiceStatuses.INVOICED);
    const fintechInvoiceColumns = {
      Division_id: (fintechId || "").toString(),
      invoice_number: ((0, _helpers.buildInvoiceNumberWithBeer)(invoice, isCustomerInvoiceNumberingActive) || "").toString(),
      invoice_date: this.showEmptyStringIfNull(invoicedStatusInfo === null || invoicedStatusInfo === void 0 ? void 0 : invoicedStatusInfo.created_at, this.company.timezone) || "",
      Vendor_store_id: (((_invoice$customer = invoice.customer) === null || _invoice$customer === void 0 ? void 0 : _invoice$customer.fintech_id) || "").toString(),
      invoice_due_date: this.showEmptyStringIfNull(invoice === null || invoice === void 0 ? void 0 : invoice.due_at) || "",
      ref_invoice_number: `YNV${invoice.number}`
    };
    invoice.items.forEach(item => {
      var _item$product, _item$product2, _item$product3, _item$product4, _formatAmount;
      const fintechItemColumn = {
        quantity_shipped: item.qty ? item.qty : "",
        Quantity_uom: "EA",
        item_number: (((_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.upc) || ((_item$product2 = item.product) === null || _item$product2 === void 0 ? void 0 : _item$product2.ydk_product_id.toFixed(0)) || item.product_id.toFixed(0) || "").toString(),
        product_description: ((_item$product3 = item.product) === null || _item$product3 === void 0 ? void 0 : _item$product3.product) + " " + ((_item$product4 = item.product) === null || _item$product4 === void 0 ? void 0 : _item$product4.product_size) || "",
        unit_price: ((_formatAmount = (0, _helpers3.formatAmount)(item.price)) === null || _formatAmount === void 0 ? void 0 : _formatAmount.replace("$", "")) || "",
        state_tax: item.taxable ? this.showStateTax(item) : 0
      };
      fintechRows.push({
        ...fintechInvoiceColumns,
        ...fintechItemColumn
      });
    });
    return fintechRows;
  }
  getRows() {
    const rows = [];

    // structure data with each row for one items
    // only export invoices for customers that have fintech option enabled
    this.invoices.forEach((invoice, i) => {
      var _invoice$customer2;
      if (!((_invoice$customer2 = invoice.customer) !== null && _invoice$customer2 !== void 0 && _invoice$customer2.fintech_option)) return;
      const invoiceRows = this.buildRows(invoice, this.company.fintech_id, i, (0, _helpers2.isCompanyFeatureActive)(this.company, _constants2.CompanyFeatures.CUSTOMER_INVOICE_NUMBERING));
      if (rows.length === 0) {
        const headers = Object.keys(invoiceRows[0] || {}).map(key => key);
        rows.push(`${headers.join(",")}`);
      }
      const escapeCSV = field => {
        const stringified = String(field ?? "");
        if (/[",\n()']/.test(stringified)) {
          return `"${stringified.replace(/"/g, '""')}"`;
        }
        return stringified;
      };
      invoiceRows.forEach(invoiceRow => {
        let columnValues = Object.values(invoiceRow);
        const parsedRow = columnValues.map(escapeCSV).join(",");
        rows.push(`${parsedRow}`);
      });
    });
    return this.createAllCapsWithoutFirstElement(rows);
  }
}
exports.InvoiceConverterFintech = InvoiceConverterFintech;